import React from "react";
import { Link } from "react-router-dom";
import PlayerHeadshot, { TeamPill, PosRank } from "@/components/PlayerHeadshot";
import PlayerBadge from "@/components/PlayerBadge";

// Canonical player row used across the app (mirrors the DME Player Values board):
// headshot + name + X-Factor/Superstar badge + optional positional rank + team pill.
// Pass a player object with { player_id, name, position, team, badge?, pos_rank?, pos_rank_delta? }.
export default function PlayerTag({
  player, size = 28, link = true, showBadge = true, showPos = false,
  showPosRank = false, className = "", nameClass = "",
}) {
  if (!player) return null;
  const { player_id, name, position, team, badge, pos_rank, pos_rank_delta, is_own } = player;
  const origin = player.origin || player.original_owner;
  const isPick = position === "PICK" || !/^\d+$/.test(String(player_id || ""));
  const linked = link && !isPick;
  const Name = linked ? Link : "span";
  const realTeam = team && team !== "FA" && team !== "PICK";
  return (
    <span className={`flex items-center gap-2 min-w-0 ${className}`} data-testid={`player-tag-${player_id}`}>
      <PlayerHeadshot playerId={player_id} name={name} team={team} size={size} />
      <span className="flex items-center gap-1.5 min-w-0">
        <Name
          {...(linked ? { to: `/app/players/${player_id}`, onClick: (e) => e.stopPropagation() } : {})}
          className={`truncate ${linked ? "hover:text-[var(--accent)]" : ""} ${nameClass}`}>
          {name}
        </Name>
        {showBadge && <PlayerBadge badge={badge} size={13} />}
        {showPosRank && pos_rank && <PosRank rank={pos_rank} delta={pos_rank_delta} className="hidden sm:inline-flex" />}
        {showPos && position && !showPosRank && (
          <span className="text-[10px] tracking-widest text-[var(--text-3)] shrink-0">{position}</span>
        )}
        {isPick && origin && (
          <span className="text-[10px] text-[var(--text-3)] shrink-0 truncate" title={is_own ? "Your own pick" : `Originally ${origin}'s pick`}>
            {is_own ? "· own" : `· via ${origin}`}
          </span>
        )}
        {realTeam && <TeamPill team={team} className="hidden sm:inline-flex" />}
      </span>
    </span>
  );
}
